export default __webpack_public_path__ + "static/media/trello.4eaa2d02.svg";